import type { TOC } from '@ember/component/template-only';
import HotelAndMarketRatesExportModalRatesExportModal from 'lumen/components/hotel-and-market/rates/export-modal/rates-export-modal';
import type HotelRatesExportController from 'lumen/controllers/hotel/rates/export';

interface HotelRatesExportSignature {
  Args: {
    controller: HotelRatesExportController;
    model: unknown;
  };
}

<template>
  {{! @glint-expect-error: Incorrect type }}
  <HotelAndMarketRatesExportModalRatesExportModal
    @cancel={{@controller.closeModal}}
    @params={{@controller.tabsParams}}
  />
</template> satisfies TOC<HotelRatesExportSignature>;
